function changeImage(el){
document.getElementById("mainProductImage").src = el.src;
}

function increase(){
let qty=document.getElementById("qty");
qty.value=parseInt(qty.value)+1;
}

function decrease(){
let qty=document.getElementById("qty");
if(qty.value>1){
qty.value=parseInt(qty.value)-1;
}
}

// document.querySelectorAll(".tab-btn").forEach(btn=>{
// btn.onclick=function(){

// document.querySelectorAll(".tab-btn").forEach(b=>b.classList.remove("active"));
// document.querySelectorAll(".tab-content").forEach(c=>c.classList.remove("active"));

// btn.classList.add("active");

// document.getElementById(btn.dataset.tab).classList.add("active");

// }
// })
const container = document.querySelector(".tab-buttons");

function scrollToCenter(btn) {
  const container = document.querySelector(".tab-buttons");

  const target =
    btn.offsetLeft - container.offsetWidth / 2 + btn.offsetWidth / 2;

  animateScroll(container, target, 600); // ✅ 900ms = 0.9s
}

function animateScroll(element, to, duration) {
  const start = element.scrollLeft;
  const change = to - start;
  const startTime = performance.now();

  function animate(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // easeInOut (smooth acceleration + deceleration)
    const ease = progress < 0.5
      ? 2 * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 2) / 2;

    element.scrollLeft = start + change * ease;

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  requestAnimationFrame(animate);
}

document.querySelectorAll(".tab-btn").forEach(btn => {

  btn.onclick = function () {

    document.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
    document.querySelectorAll(".tab-content").forEach(c => c.classList.remove("active"));

    btn.classList.add("active");
    document.getElementById(btn.dataset.tab).classList.add("active");

    // 🔥 ADD THIS LINE (center active tab)
    scrollToCenter(btn);
  }

});
var thumbs = new Swiper(".productThumbs", {
  spaceBetween: 10,
  slidesPerView: 3.2,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
});

var swiper = new Swiper(".productSwiper", {
  spaceBetween: 10,
  loop: false,

  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
  },

  navigation: {
    nextEl: ".productSwiper .swiper-button-next",
    prevEl: ".productSwiper .swiper-button-prev",
  },

  thumbs: {
    swiper: thumbs,
  },
});

function centerThumb(index) {
  const total = thumbs.slides.length;
  const perView = Math.floor(thumbs.params.slidesPerView);

  let centerIndex = index - Math.floor(perView / 2);

  if (centerIndex < 0) centerIndex = 0;
  if (centerIndex > total - perView) centerIndex = total - perView;

  thumbs.slideTo(centerIndex);
}

// page load
window.addEventListener("load", () => {
  const activeBtn = document.querySelector(".tab-btn.active");

  if (swiper) {
    centerThumb(swiper.activeIndex);
  }

  if (activeBtn) {
    scrollToCenter(activeBtn);
  }

  if (swiper.isBeginning) {
    document
      .querySelector(".new-button-prev")
      ?.classList.add("swiper-button-disabled");
  }
});

// thumb click center
thumbs.on("click", function () {
  if (thumbs.clickedIndex !== undefined) {
    swiper.slideTo(thumbs.clickedIndex);
    centerThumb(thumbs.clickedIndex);
  }
});

// main slide change center thumb
swiper.on("slideChange", function () {
  centerThumb(swiper.activeIndex);
});
// ✅ FORCE disable on first load


document.querySelectorAll(".wishlist-btn").forEach(btn => {

let productId = btn.dataset.productId;

let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

/* Check if already saved */

if(wishlist.find(item => item.id === productId)){
btn.classList.add("active");
}

btn.addEventListener("click", function(){

let product = {
id: btn.dataset.productId,
title: btn.dataset.productTitle,
url: btn.dataset.productUrl,
image: btn.dataset.productImage,
price: btn.dataset.productPrice
};

let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

let exists = wishlist.find(item => item.id === product.id);

if(exists){

wishlist = wishlist.filter(item => item.id !== product.id);
btn.classList.remove("active");

}else{

wishlist.push(product);
btn.classList.add("active");

}

localStorage.setItem("wishlist", JSON.stringify(wishlist));

});

});



// document.querySelectorAll(".variant-btn").forEach(btn => {

//   btn.addEventListener("click", function(){

//     document.querySelectorAll(".variant-btn").forEach(b=>b.classList.remove("active"));
//     this.classList.add("active");

//     let price = this.dataset.price;
//     let compare = this.dataset.compare;
//     let variantId = this.dataset.id;
//     let coverage = this.dataset.coverage;

//     document.getElementById("productPrice").innerText = price;

//     if(compare){
//       document.getElementById("comparePrice").innerText = compare;
//     }

//     // ✅ update coverage
//     document.getElementById("coverageValue").innerText = coverage;

//     // ✅ update variant id
//     document.getElementById("variantId").value = variantId;

//   });

// });
// document.addEventListener("DOMContentLoaded", function () {

//   const buttons = document.querySelectorAll(".variant-btn");

//   const formatMoney = (amount) => {
//     return "₹" + (amount / 100).toFixed(2);
//   };


//     const updateVariant = (btn) => {
//       buttons.forEach(b => b.classList.remove("active"));
//       btn.classList.add("active");

//      console.log(btn.dataset);

//       let price = btn.dataset.price;
//       let compare = btn.dataset.compare;
//       let variantId = btn.dataset.id;
//       let coverage = btn.dataset.coverage;
//       let image = btn.dataset.image;
//       let thumb = btn.dataset.thumb;

//       document.getElementById("productPrice").innerText = formatMoney(price);

//       if (compare && Number(compare) > Number(price)) {
//         document.getElementById("comparePrice").innerText = formatMoney(compare);
//         document.getElementById("comparePrice").style.display = "inline";
//       } else {
//         document.getElementById("comparePrice").innerText = "";
//         document.getElementById("comparePrice").style.display = "none";
//       }

//       document.getElementById("coverageValue").innerText =
//         (coverage && coverage !== "null" && coverage !== "")
//           ? coverage
//           : defaultCoverage;

//       document.getElementById("variantId").value = variantId;

//       if (image) {
//         document.getElementById("mainProductImage").src = image;
//       }

//       if (thumb) {
//         document.getElementById("thumbProductImage").src = thumb;
//       }

//       const newUrl = `${window.location.pathname}?variant=${variantId}`;
//       window.history.replaceState(null, "", newUrl);
//     };

//   // 🔥 Click event
//   buttons.forEach(btn => {
//     btn.addEventListener("click", function () {
//       updateVariant(this);
//     });
//   });

//   // ✅ Load from URL
//   const urlParams = new URLSearchParams(window.location.search);
//   const variantIdFromUrl = urlParams.get("variant");

//   if (variantIdFromUrl) {
//     const targetBtn = document.querySelector(`.variant-btn[data-id="${variantIdFromUrl}"]`);
//     if (targetBtn) {
//       updateVariant(targetBtn);
//     }
//   } else {
//     // fallback
//     const firstActive = document.querySelector(".variant-btn.active") || buttons[0];
//     if (firstActive) updateVariant(firstActive);
//   }

// });

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".variant-btn");

  const formatMoney = (amount) => {
    return "₹" + (Number(amount) / 100).toFixed(2);
  };

  const updateGallery = (btn) => {
    const mainWrapper = document.querySelector(".productSwiper .swiper-wrapper");
    const thumbWrapper = document.querySelector(".productThumbs .swiper-wrapper");

    let images = [];

    try {
      images = JSON.parse(btn.dataset.images || "[]");
    } catch (e) {
      images = [];
    }

    let allImages = [];

    if (btn.dataset.image) {
      allImages.push({
        main: btn.dataset.image,
        thumb: btn.dataset.thumb || btn.dataset.image,
      });
    }

    if (Array.isArray(images)) {
      images.forEach((img) => {
        let imageUrl = "";

        if (typeof img === "string") {
          imageUrl = img;
        } else if (img?.src) {
          imageUrl = img.src;
        } else if (img?.preview_image?.src) {
          imageUrl = img.preview_image.src;
        } else if (img?.url) {
          imageUrl = img.url;
        }

        if (imageUrl) {
          allImages.push({
            main: imageUrl,
            thumb: imageUrl,
          });
        }
      });
    }

    mainWrapper.innerHTML = "";
    thumbWrapper.innerHTML = "";

    allImages.forEach((img) => {
      mainWrapper.innerHTML += `
        <div class="swiper-slide swiper-slide-a">
          <img src="${img.main}" alt="">
        </div>
      `;

      thumbWrapper.innerHTML += `
        <div class="swiper-slide">
          <img src="${img.thumb}" alt="">
        </div>
      `;
    });

    swiper.update();
    thumbs.update();

    swiper.slideTo(0);
    thumbs.slideTo(0);
  };

  const updateVariant = (btn) => {
    buttons.forEach((b) => b.classList.remove("active"));
    btn.classList.add("active");

    let price = btn.dataset.price;
    let compare = btn.dataset.compare;
    let variantId = btn.dataset.id;
    let coverage = btn.dataset.coverage;

    document.getElementById("productPrice").innerText = formatMoney(price);

    if (compare && Number(compare) > Number(price)) {
      document.getElementById("comparePrice").innerText = formatMoney(compare);
      document.getElementById("comparePrice").style.display = "inline";
    } else {
      document.getElementById("comparePrice").innerText = "";
      document.getElementById("comparePrice").style.display = "none";
    }

    document.getElementById("coverageValue").innerText =
      coverage && coverage !== "null" && coverage !== ""
        ? coverage
        : defaultCoverage;

    document.getElementById("variantId").value = variantId;

    updateGallery(btn);

    const newUrl = `${window.location.pathname}?variant=${variantId}`;
    window.history.replaceState(null, "", newUrl);
  };

  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      updateVariant(this);
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const variantIdFromUrl = urlParams.get("variant");

  if (variantIdFromUrl) {
    const targetBtn = document.querySelector(
      `.variant-btn[data-id="${variantIdFromUrl}"]`
    );
    if (targetBtn) updateVariant(targetBtn);
  } else {
    const firstActive =
      document.querySelector(".variant-btn.active") || buttons[0];

    if (firstActive) updateVariant(firstActive);
  }
});